import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.css']
})
export class TitleComponent {
  @Input() backgroundColor: string = '#60e1cb';
  @Input() message:string = '' // Valor por defecto o puedes dejarlo sin valor por defecto
}
